import React from "react";
import {EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton,} from "react-share";

const listArray = [
    <FacebookShareButton
        url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
        quote={"Share me"}
        style={{width: 40, height: 40}}
    >
        <div className="facebookicon"/>
    </FacebookShareButton>,
    <WhatsappShareButton
        url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
        quote={"Share me"}
        style={{width: 40, height: 40}}
    >
        <div className="whatsappicon"/>
    </WhatsappShareButton>,
    <TwitterShareButton
        url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
        quote={"Share me"}
        style={{width: 40, height: 40}}
    >
        <div className="twittericon"/>
    </TwitterShareButton>,
    <EmailShareButton
        url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
        quote={"Share me"}
        style={{width: 40, height: 40}}
    >
        <div className="emailicon"/>
    </EmailShareButton>,
];

const getListArray = (url)=>{
    return [
        <FacebookShareButton
            url={url}
            quote={"Share me"}
            style={{width: 40, height: 40}}
        >
            <div className="facebookicon"/>
        </FacebookShareButton>,
        <WhatsappShareButton
            url={url}
            quote={"Share me"}
            style={{width: 40, height: 40}}
        >
            <div className="whatsappicon"/>
        </WhatsappShareButton>,
        <TwitterShareButton
            url={url}
            quote={"Share me"}
            style={{width: 40, height: 40}}
        >
            <div className="twittericon"/>
        </TwitterShareButton>,
        <EmailShareButton
            url={url}
            quote={"Share me"}
            style={{width: 40, height: 40}}
        >
            <div className="emailicon"/>
        </EmailShareButton>,
    ];
}

export default{
    listArray,
    getListArray
}